import { render } from "./GanttComponent.vue?vue&type=template&id=43baf462&scoped=true"
import script from "./GanttComponent.vue?vue&type=script&lang=js"
export * from "./GanttComponent.vue?vue&type=script&lang=js"

import "./GanttComponent.vue?vue&type=style&index=0&id=43baf462&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43baf462"]])

export default __exports__